// extracted by mini-css-extract-plugin
export default {"overlay":"cJ_kG","container":"cJ_g","containerSingleColumn":"cJ_kH","title":"cJ_cX","closeButton":"cJ_fP"};